import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigPdvResponse } from '../../responses/vendas/get-config-pdv.response';
import { ConfigPdvLookupsResponse } from '../../responses/vendas/config-pdv-lookups.response';
import { ConfigPdvRequest } from '../../requests/vendas/config-pdv.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigPdvService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigPdv';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigPdvResponse> {
        return this.httpClient
            .get<GetConfigPdvResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigPdvLookupsResponse> {
        return this.httpClient
            .get<ConfigPdvLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigPdvRequest): Observable<GetConfigPdvResponse> {
        const url = `${this.apiUrl}/idConfigPdv/${id}`;
        return this.httpClient
            .put<GetConfigPdvResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
